import { render, staticRenderFns } from "./Know.vue?vue&type=template&id=aa23fb7c&scoped=true"
import script from "./Know.vue?vue&type=script&lang=js"
export * from "./Know.vue?vue&type=script&lang=js"
import style0 from "./Know.vue?vue&type=style&index=0&id=aa23fb7c&prod&lang=css"
import style1 from "./Know.vue?vue&type=style&index=1&id=aa23fb7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa23fb7c",
  null
  
)

export default component.exports